import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'errorKeys',
  pure: true,
  standalone: true,
})
export class ErrorMessagesPipe implements PipeTransform {
  transform(errors: ValidationErrors | null): string[] {
    if (!errors) {
      return [];
    }
    return Object.keys(errors);
  }
}
